/* Single navigation seam for non-component code (redux thunks, the api.ts 401
   interceptor, chart handlers). NavigationBridge installs the router's
   navigate via setNavigate; before it mounts (or after it unmounts) the
   fallback does a full-page window.location navigation. */

type NavigateOpts = { replace?: boolean };
type NavigateFn = (to: string | number, opts?: NavigateOpts) => void;

let installedNavigate: NavigateFn | null = null;

export function setNavigate(fn: NavigateFn | null): void {
  installedNavigate = fn;
}

export function appNavigate(to: string, opts?: NavigateOpts): void {
  if (installedNavigate) {
    installedNavigate(to, opts);
  } else if (opts?.replace) {
    window.location.replace(to);
  } else {
    window.location.assign(to);
  }
}

/* Navigate back to the page the user came from — e.g. after saving a settings
   form that was opened from the dashboard (review #19). Falls back to a fixed
   target when there is no in-app history entry to return to (deep link, fresh
   tab) or no router navigate is installed. */
export function appNavigateBack(fallback: string): void {
  // react-router stamps an incrementing `idx` into history.state; 0 means this
  // is the first in-app entry, so "back" would leave the app.
  const idx = window.history?.state?.idx ?? 0;
  if (installedNavigate && idx > 0) {
    installedNavigate(-1);
  } else {
    appNavigate(fallback, { replace: true });
  }
}

export function currentLocation(): { pathname: string; search: string } {
  return {
    pathname: window.location.pathname,
    search: window.location.search,
  };
}
